import { ChevronLeft, ChevronRight } from 'lucide-react';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  isLoading?: boolean;
  className?: string;
}

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  isLoading = false,
  className = '',
}: PaginationProps) => {
  // Don't render if only one page
//   if (totalPages <= 1) {
//     return null;
//   }

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div className={`flex justify-center items-center gap-2 mt-8 ${className}`}>
      <button
        onClick={handlePrevious}
        disabled={currentPage === 1 || isLoading}
        className="px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        title="Previous page"
      >
        <ChevronLeft className="h-5 w-5" />
      </button>

      <span className="text-gray-600 font-medium min-w-max">
        Page {currentPage} of {totalPages}
      </span>

      <button
        onClick={handleNext}
        disabled={currentPage === totalPages || isLoading}
        className="px-4 py-2 bg-primary hover:bg-primary/90 text-white rounded-lg disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        title="Next page"
      >
        <ChevronRight className="h-5 w-5" />
      </button>
    </div>
  );
};

Pagination.displayName = 'Pagination';

export default Pagination;
